import React, { Component } from 'react';
import { Progress, Icon } from 'antd-mobile';
import PropTypes from 'prop-types';

import styles from './styles.module.less';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  iconType: PropTypes.string,
  iconSize: PropTypes.string,
};

const defaultProps = {
  iconType: 'loading',
  iconSize: 'xs',
};

/**
 * 进度条
 */
class ProgressComponent extends Component {
  timer = null;

  constructor(props) {
    super(props);
    this.state = {
      schedule: 0,
    };
  }

  componentDidMount() {
    this.setAddScheduleListen();
  }

  componentDidUpdate(prevProps) {
    const { loading } = this.props;
    if (!prevProps.loading && loading) {
      this.setAddScheduleListen();
    }
  }

  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer);
  }

  setAddScheduleListen = () => {
    this.timer = setInterval(() => {
      this.addSchedule();
    }, 100);
  };

  addSchedule = () => {
    let { schedule } = this.state;
    const { loading } = this.props;
    if (schedule >= 90 && loading) return false;

    schedule += 30;

    if (schedule >= 100) {
      clearInterval(this.timer);
      schedule = 100;
    }

    this.setState({ schedule });
    return true;
  };

  render() {
    const { iconType, iconSize } = this.props;
    const { schedule } = this.state;
    return (
      <>
        {
          schedule >= 100 ? null
            : (
              <div className={styles.progressBox}>
                <Progress percent={schedule} position="fixed" />
                <Icon className={styles.loadingIcon} type={iconType} size={iconSize} />
              </div>
            )
        }
      </>
    );
  }
}

ProgressComponent.propTypes = propTypes;
ProgressComponent.defaultProps = defaultProps;

export default ProgressComponent;
